import React, { useEffect, useState } from "react";

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  CardTitle,
  Button,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";

// import { productListvar } from "../../common/data";
import { getCart as onGetCart } from "slices/thunk";
import EcommerceOrder from "./CardsUser";
import { toast } from "react-toastify";

const EcommerceCart = () => {
  //meta title
  document.title = "Ditobanx";

  const selectProperties = createSelector(
    (state: any) => state.ecommerce,
    (ecommerce) => ({
      cart: ecommerce?.cart || [],
    })
  );

  const { cart } = useSelector(selectProperties);

  const dispatch = useDispatch<any>();
  const [productList, setproductList] = useState<any>();
  const [dic, setDic] = useState<number>(0);
  const [tax, setTax] = useState<number>(0);
  const [charge, setCharge] = useState<number>(0);

  const assigned = (productList || [])?.map((item: any) => item.total);
  let subTotal = 0;
  for (let i = 0; i < assigned.length; i++) {
    subTotal += Math.round(assigned[i]);
  }

  useEffect(() => {
    let dic = 0.15 * subTotal;
    let tax = 0.125 * subTotal;
    if (subTotal !== 0) {
      setCharge(65);
    } else {
      setCharge(0);
    }
    setDic(dic);
    setTax(tax);
  }, [subTotal]);

  useEffect(() => {
    // dispatch(onGetCart());
  }, [dispatch]);

  // ? SE COMENTO ESTO DEBIDO A MULTIPLEZ PETICIONES AL SERVIDOR Y NO SE ACTUALIZA EL ESTADO
  useEffect(() => {
    // setproductList((prevList) => (prevList !== cart ? cart : prevList));
  }, [cart]);

  const requestCard = () => {
    toast.success("Your Card has been requested", { autoClose: 2000 });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Ecommerce" breadcrumbItem="Cards" />
          <Row>
            <Col xl={8}>
              <EcommerceOrder />
            </Col>
            {/* CARD DETAILS */}
            <Col xl="4">
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Card Details</CardTitle>
                  <Card color="primary" className="text-white visa-card mb-0">
                    <CardBody>
                      <div>
                        <i className="bx bxl-mastercard visa-pattern" />
                        <div className="float-end">
                          <i className="bx bxl-mastercard visa-logo display-3" />
                        </div>
                        <div>
                          <i
                            className="bx bx-chip h1 text-warning"
                            style={{ lineHeight: 1 }}
                          />
                        </div>
                      </div>

                      <Row className="mt-5">
                        <Col xs={4}>
                          <p>
                            <i className="fas fa-star-of-life m-1" />
                            <i className="fas fa-star-of-life m-1" />
                            <i className="fas fa-star-of-life m-1" />
                          </p>
                        </Col>
                        <Col xs={4}>
                          <p>
                            <i className="fas fa-star-of-life m-1" />
                            <i className="fas fa-star-of-life m-1" />
                            <i className="fas fa-star-of-life m-1" />
                          </p>
                        </Col>
                        <Col xs={4}>
                          <p>
                            <i className="fas fa-star-of-life m-1" />
                            <i className="fas fa-star-of-life m-1" />
                            <i className="fas fa-star-of-life m-1" />
                          </p>
                        </Col>
                      </Row>

                      <div className="mt-5">
                        <h5 className="text-white float-end mb-0">12/22</h5>
                        <h5 className="text-white mb-0">
                          Asigned to: Fredrick Taylor
                        </h5>
                      </div>
                    </CardBody>
                  </Card>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <CardTitle className="mb-3">Card Information</CardTitle>
                  <div className="table-responsive">
                    <Table className="table mb-0">
                      <tbody>
                        <tr>
                          <td>Belongs To :</td>
                          <td>Refael Nadal</td>
                        </tr>
                        <tr>
                          <td>Active :</td>
                          <td>True</td>
                        </tr>
                        <tr>
                          <td>Card Number : </td>
                          <td>000000000</td>
                        </tr>
                        <tr>
                          <td>Expired Date :</td>
                          <td>28/03</td>
                        </tr>
                        <tr>
                          <td>CVV : </td>
                          <td>458</td>
                        </tr>
                        <Button
                          type="button"
                          className="btn btn-success mt-3"
                          onClick={requestCard}
                        >
                          Solicitar Tarjeta
                        </Button>
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EcommerceCart;
